<div [ngClass]="['srs-card', 'card', 'p-3', height100 ? 'h-100' : '', title == null ? 'no-top-margin' : '']">
  <h6 *ngIf="title">{{title}}</h6>
  <ng-content></ng-content>
</div>
